import pdpVideo from './product/pdpVideo';


var processInclude = require('base/util');

// eslint-disable-next-line no-undef
$(document).ready(function () {
    processInclude(pdpVideo);
});
